import type { FaireProductEntity } from "../../entity_types/product";

export const p_54w7dngnxh: FaireProductEntity = {
  token: "p_54w7dngnxh",
  type: "product",
  name: "Mahjong Needlepoint Pillow",
  brandToken: "b_442tb6k986",
  brandName: "Furbish Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/c519ccdd4bbf58fa483f3824434b7b252d4ce39c9246b69756f79be7f7d10264.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/59abbb1d3dfb654b9f7b15873556180c0d836b63365462951e98bbc3cea0a78d.jpeg",
    "https://cdn.faire.com/fastly/814f6d9f54c47ab55fd893da99f1598cf8621e9af36c15da707bfbbea2152304.jpeg",
    "https://cdn.faire.com/fastly/d233419bcdfae72e38dd53f0dbafce95dcb0857fddfc55369115c9a964541274.jpeg",
    "https://cdn.faire.com/fastly/dfac6372dd76dac4c57f4868457301e3dcbdb03fc21f1b7a2d6449eaf3ede265.jpeg",
    "https://cdn.faire.com/fastly/71ab6c9399fea3bd1c535c3c68bc62e61b6f360e275afc992ac8a3eb0b4c236c.jpeg",
  ],
  priceDollars: 49,
  description:
    'For the ones who know that the best way to spend time is with a hand full of tiles and a good laugh. This pillow is for those who believe in playing Mahjong forever—because a game of strategy and fun beats housework every time.\n\nEmbrace the latest joy-inspired decor movement, and transform your home with Furbish Studio’s Needlepoint and Statement Pillows. Our pillows feature vibrant patterns, playful prints and uniquely-you sayings that spark happiness and guarantee LOLs – because your home should make you smile every day. \n\nEmbroidered and backed in luxe velvet, we\'ve revived a Southern craft with charming sayings that are sure to get a smile. With over 100 styles to choose from, they are sure to spark joy, plus they make the perfect gift! Check out the full collection here.\n\nMeasures 9" x 15" - Small pillow, big statement!',
  tags: [],
  msrpDollars: 98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:46.939Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
